<div
  (click)="selectItem()"
  class="tw-cursor-pointer tw-group tw-flex tw-bg-gray-800 tw-bg-opacity-30 tw-border tw-border-solid tw-border-gray-700 tw-border-opacity-50 tw-rounded-xl tw-transition-colors tw-duration-200 hover:tw-bg-gray-800 hover:tw-bg-opacity-50 hover:tw-border-teal-600 hover:tw-border-opacity-60">
  <!-- Left Column - Main Content -->
  <button
    class="tw-flex-1 tw-h-full focus:tw-outline-none focus:tw-rounded-l-xl tw-py-3 tw-pl-3 tw-text-left"
    aria-label="Select this role">
    <div class="tw-flex tw-items-center tw-gap-3 tw-mb-1">
      <div
        class="tw-text-white tw-font-medium tw-flex tw-items-center tw-gap-1"
        [matTooltip]="item?.description || ''"
        [matTooltipDisabled]="!item?.description"
        matTooltipPosition="above">
        {{ item?.name || 'Unnamed Role' }}
      </div>
      <div class="tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
        <span
          class="tw-bg-teal-600 tw-text-white tw-text-xs tw-font-medium tw-px-2 tw-py-1 tw-rounded-md">
          Select
        </span>
      </div>
    </div>

    <div
      *ngIf="showCreator && item?.createdBy && item?.scope !== 'public'"
      class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-400 tw-mb-2">
      <mat-icon class="tw-text-gray-400 tw-h-5 tw-w-5 tw-text-[18px]"> person_outline </mat-icon>
      <span class="tw-text-sm tw-text-gray-400">{{ item.createdBy }}</span>
    </div>

    <!-- Top 10 matching titles section -->
    <div>
      <button
        (click)="toggleExpansion($event)"
        class="tw-group/expand tw-bg-transparent tw-border-none tw-p-0 tw-text-left tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"
        aria-label="Toggle list expansion">
        <span
          class="tw-text-sm tw-text-gray-400 tw-flex tw-items-center tw-gap-1.5 hover:tw-text-gray-300 tw-transition-colors">
          <mat-icon class="tw-text-base">format_list_bulleted</mat-icon>
          <span
            class="tw-transition-all group-hover/expand:tw-underline group-hover/expand:tw-text-teal-400 group-hover/expand:tw-underline-offset-4">
            Top matching titles
          </span>
          <mat-icon
            class="tw-text-base tw-transition-transform tw-ml-1"
            [class.tw-rotate-180]="isExpanded">
            expand_more
          </mat-icon>
        </span>
      </button>
      <div *ngIf="isExpanded" class="tw-mt-2 tw-space-y-2 fade-in">
        <div
          *ngIf="isLoadingTitles"
          class="tw-text-sm tw-text-gray-400 tw-pl-6 tw-flex tw-items-center tw-gap-2">
          <mat-icon class="tw-text-base tw-text-gray-500">hourglass_empty</mat-icon>
          <span>Loading titles…</span>
        </div>
        <div *ngIf="!isLoadingTitles && titles.length > 0" class="tw-space-y-2">
          <div
            *ngFor="let title of titles"
            class="tw-text-sm tw-text-gray-400 tw-pl-6 tw-flex tw-items-center tw-gap-2">
            <mat-icon class="tw-text-base tw-text-gray-500">work</mat-icon>
            <span class="tw-text-left">{{ title }}</span>
          </div>
        </div>
        <div *ngIf="!isLoadingTitles && titles.length === 0" class="tw-space-y-2">
          <div class="tw-text-sm tw-text-gray-400 tw-pl-6 tw-italic">
            No matching titles available
          </div>
        </div>
      </div>
    </div>
  </button>

  <!-- Right Column - Action Buttons -->
  <div
    class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-1 tw-px-3 tw-py-3 tw-min-h-full">
    <button
      type="button"
      class="tw-rounded-md tw-text-sm tw-text-gray-300 tw-border tw-border-solid tw-border-gray-500 tw-h-7"
      matTooltip="View role details"
      matTooltipPosition="above"
      (click)="viewDetails($event)">
      <mat-icon class="tw-text-[20px] tw-leading-[24px]">visibility</mat-icon>
    </button>

    <!-- Admin Menu -->
    <app-admin-menu
      [scopeToggleText]="getScopeToggleText()"
      [scopeToggleIcon]="getScopeToggleIcon()"
      (copyToOrg)="onCopyToOrg($event)"
      (toggleScope)="onToggleScope($event)">
    </app-admin-menu>

    <div *ngIf="allowDelete">
      <button
        (click)="deleteItem($event)"
        class="tw-rounded-md tw-text-sm tw-text-red-400 hover:tw-text-red-300 tw-border tw-border-solid tw-border-red-500 tw-h-7"
        aria-label="Delete this role">
        <mat-icon class="tw-text-[20px] tw-leading-[24px]">delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
